import React, { CSSProperties, ReactElement, ReactNode } from 'react';
import GridItem from '../layout/GridComponents/GridItem';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import Pill from '../ui/Pill';
import { cn } from '../../utilities/cn';

const useOverviewCardStyles = makeStyles(() => ({
  root: {
    alignSelf: 'stretch',
    cursor: 'pointer',
    transition: 'all 0.3s',
    '&:hover': {
      transform: 'scale(0.98)',
    },
  },
  link: {
    textDecoration: 'none',
  },
}));

interface OverviewCardProps {
  backgroundColor?: string;
  clickHandler?: () => void;
  additionalCardStyles?: CSSProperties;
  toVal: string;
  children: ReactNode;
  /** When true, shows a Demo pill and a left purple accent. Status fill is unchanged. */
  isDemoFund?: boolean;
}

const OverviewCard: React.FC<OverviewCardProps> = (
  props,
): ReactElement | null => {
  const classes = useOverviewCardStyles();
  const isDemoFund = !!props.isDemoFund;

  return (
    <GridItem
      classes={{
        root: classes.root,
      }}
      cardStyle={{
        padding: '0.62rem',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: props.backgroundColor || 'white',
        ...props.additionalCardStyles,
      }}
      onClick={props.clickHandler}
      card
      xs={2}
    >
      {isDemoFund ? (
        <>
          <span
            className="pointer-events-none absolute inset-y-0 left-0 z-10 w-1 bg-demo"
            aria-hidden
          />
          <span className="pointer-events-none absolute right-2 top-2 z-10">
            <Pill status="demo" className="bg-white/90 shadow-sm">
              Demo
            </Pill>
          </span>
        </>
      ) : null}
      <Link
        to={props.toVal}
        className={cn(classes.link, isDemoFund && 'pr-12')}
      >
        {props.children}
      </Link>
    </GridItem>
  );
};

export default OverviewCard;
